var map = {
	"./about-page-large.jpg": 261,
	"./about-page-medium.jpg": 360,
	"./about-page-small.jpg": 393,
	"./main-page-large.jpg": 711,
	"./main-page-medium.jpg": 825,
	"./main-page-small.jpg": 951
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 881;